import dayjs from 'dayjs'
import { VFC } from 'react'
import { CLOSE_WITH_CIRCLE_ICON } from 'src/assets/images'
import { TooltipWrapper } from 'src/components/Tooltip'
import { Link } from 'src/elements/Link'
import { RequestBoxCompany } from 'src/models/RequestBox'
import {
  _forminputback,
  _messagebuttonbg,
  _messageformborder,
  _profilegreen,
  truewhite,
} from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import styled from 'styled-components'

const BANNER_HEIGHT = 54
const senderTooltipNode =
  '日程調整URLを登録している場合、つながり申請やメッセージを送ってつながりが成立するとあなたの日程調整URLが相手に７日間自動表示されます。7日経つと日程調整URLは自動で非表示になります。'
const receiverTooltipNode =
  'つながり申請やメッセージを送信した相手が日程調整URLを登録している場合、つながり成立後相手の日程調整URLが７日間ルーム内に自動表示されます。7日経つと日程調整URLは自動で非表示になります。'
const DESCRIPTION_1 = '送信者が日程調整URLを登録していません'
const DESCRIPTION_2 =
  'つながりが成立してから７日間経過したためこちらから日程調整はできません。日程調整を行う場合はご自身のURLをメッセージに記入してください。'
const DESCRIPTION_3 = 'つながり成立後7日間、あなたの日程調整URLが表示されます'
const DESCRIPTION_4 =
  '日程調整URLの表示期間が終了しました。URLの再送はメッセージより送信ください'
const DESCRIPTION_5 = (url: string) => (
  <p>
    つながり成立後7日間、相手の日程調整URLが
    <Link href={url}>こちらから見れます。</Link>
    <br />
    日程登録後には登録完了のメッセージ送信を相手にお願いいたします。
  </p>
)

const ScheduleUrlRegistrationBannerComponent: VFC<{
  className?: string
  open: () => void
  openBannerCloseModal: () => void
}> = ({ className, open, openBannerCloseModal }) => {
  return (
    <BannerDiv className={className}>
      <button type={'button'} onClick={() => open()}>
        あなたの日程調整URLを登録できます。登録はこちら→
      </button>
      <button onClick={() => openBannerCloseModal()}>
        <img src={CLOSE_WITH_CIRCLE_ICON} alt="閉じる" width={20} />
      </button>
    </BannerDiv>
  )
}
export const ScheduleUrlRegistrationBanner = styled(
  ScheduleUrlRegistrationBannerComponent,
)``

export const ScheduleUrlBanner: VFC<{
  requestBox?: RequestBoxCompany
  myScheduleUrl?: string
  sentRequest: boolean
}> = ({ requestBox, myScheduleUrl, sentRequest }) => {
  return (
    <ScheduleUrlBannerWrapper>
      <TooltipWrapper
        tooltipNode={sentRequest ? senderTooltipNode : receiverTooltipNode}
        top={-80}
        tooltipStyle={'color: black; background-color: white'}
        type={'scheduleUrl'}
        isWrap={true}
      >
        {sentRequest ? (
          !!dayjs(requestBox?.matchAt).day() &&
          myScheduleUrl && (
            <ScheduleUrlBannerDiv isGreen={false}>
              <SenderDescriptionTag requestBox={requestBox} />
            </ScheduleUrlBannerDiv>
          )
        ) : (
          <ScheduleUrlBannerDiv
            isGreen={
              (requestBox?.schedule?.url &&
                requestBox?.schedule?.within7Days) ||
              false
            }
          >
            <ReceiverDescriptionTag requestBox={requestBox} />
          </ScheduleUrlBannerDiv>
        )}
      </TooltipWrapper>
    </ScheduleUrlBannerWrapper>
  )
}

const ReceiverDescriptionTag: VFC<{ requestBox?: RequestBoxCompany }> = ({
  requestBox,
}) => {
  if (!requestBox || !requestBox.schedule) return <></>
  if (requestBox.schedule.url && requestBox.schedule.within7Days)
    return DESCRIPTION_5(requestBox.schedule.url)
  if (
    !requestBox.schedule.url &&
    dayjs(requestBox.matchAt) &&
    !requestBox.schedule.within7Days
  )
    return <p>{DESCRIPTION_2}</p>
  return <p>{DESCRIPTION_1}</p>
}

const SenderDescriptionTag: VFC<{ requestBox?: RequestBoxCompany }> = ({
  requestBox,
}) => {
  if (!requestBox || !requestBox.schedule) return <></>
  if (requestBox.schedule.within7Days) return <p>{DESCRIPTION_3}</p>
  return <p>{DESCRIPTION_4}</p>
}

const BannerDiv = styled.div`
  color: ${truewhite};
  min-height: ${BANNER_HEIGHT}px;
  z-index: 1;
  margin-right: 16px;
  color: ${_profilegreen};
  background: ${_forminputback};
  font-size: 14px;
  font-weight: ${fontWeightBold};
  letter-spacing: 1px;
  display: flex;
  justify-content: space-between;

  button {
    margin: auto 40px;
    line-height: ${BANNER_HEIGHT}px;

    img {
      vertical-align: middle;
      margin-right: -40px;
    }
  }

  @media screen and (max-width: 960px) {
    display: none;
  }
`

const ScheduleUrlBannerDiv = styled.div<{ isGreen: boolean }>`
  position: relative;
  bottom: -4px;
  color: ${truewhite};
  font-weight: ${fontWeightBold};
  font-size: 14px;
  border-radius: 5px 5px 0px 0px;
  width: 100%;
  padding: 10px 24px 14px 24px;
  letter-spacing: 1px;
  line-height: 150%;
  background: ${({ isGreen }) => (isGreen ? `${_messagebuttonbg}` : '#d9d9d9')};

  a {
    border-bottom: 1px solid ${_messageformborder};
  }
`
const ScheduleUrlBannerWrapper = styled.div`
  @media screen and (max-width: 960px) {
    display: none;
  }
`
